import React from 'react';
import { BatcheDetailContainer } from '../../../containers';

export const BatcheDetail = () => <BatcheDetailContainer />;
